export default __webpack_public_path__ + "static/media/misc-closetC-1024w.3b4eca84.webp";